import { ConfirmationModal, ToastMessage } from './model';

import { BusinessResult } from '../../business/models/policy-business.model';
import { SharedActionTypes } from './types';
import { action } from 'typesafe-actions';

export const setCurrentUserInfo = (currentLanguage: string,
                                    username: string,
                                    firstName: string,
                                    lastName: string,
                                    parentPartyName: string,
                                    parentPartyDibCode: string,
                                    parentPartyId: number,
                                    useMfa: boolean,
                                    roles: string[],
                                    mfaQRCode: string,
                                    registeredForMfa: boolean) => action(SharedActionTypes.SET_CURRENT_USER_INFO, { currentLanguage, username, firstName, lastName, parentPartyName, parentPartyDibCode, parentPartyId, useMfa, roles, mfaQRCode, registeredForMfa });
export const toggleIsUIDisabled = (isDisabled: boolean) => action(SharedActionTypes.TOGGLE_IS_UI_DISABLED, isDisabled);
export const setToastMessage = (message?: ToastMessage) => action(SharedActionTypes.SET_TOAST_MESSAGE, { message });
export const showConfirmationModal = (modal: ConfirmationModal) => action(SharedActionTypes.SHOW_CONFIRMATION_MODAL, modal);
export const hideConfirmationModal = () => action(SharedActionTypes.HIDE_CONFIRMATION_MODAL);
export const confirmationModalOK = () => action(SharedActionTypes.CONFIRMATION_MODAL_OK);
export const confirmationModalCancel = () => action(SharedActionTypes.CONFIRMATION_MODAL_CANCEL);
export const businessUpdate = (data: BusinessResult) => action(SharedActionTypes.BUSINESS_UPDATE, data);
export const validateEmail = (email: string) => action(SharedActionTypes.VALIDATE_EMAIL, { email });

export const getDownloadLink = (
          amazonKey: string,
          url: string,
          content: string,
          filename: string,
          bucketName?: string
        ) => action(SharedActionTypes.GET_DOWNLOAD_LINK, { amazonKey, url, content, filename, bucketName });

export const getDownloadLinkSuccess = (data: { amazonKey: string; url: string; filename: string }) =>
     action(SharedActionTypes.GET_DOWNLOAD_LINK_SUCCESS, data);
   
export const getDownloadLinkFail = (error: string) =>
     action(SharedActionTypes.GET_DOWNLOAD_LINK_FAIL, error);

export const setMobileView = (isMobileView: boolean) => action(SharedActionTypes.SET_MOBILE_VIEW, isMobileView );
